import * as UTIF from "utif";

const TIFF_MIME = "image/tiff";
const TIFF_EXTENSION = /\.tiff?$/i;

export const isTiff = (nameOrUrl = "", mimeType = ""): boolean =>
  mimeType.toLowerCase() === TIFF_MIME || TIFF_EXTENSION.test(nameOrUrl.split("?")[0]);

const canvasToPngBlob = (canvas: HTMLCanvasElement): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }
      reject(new Error("TIFF conversion failed"));
    }, "image/png");
  });

export const tiffToPngUrl = async (source: Blob): Promise<string> => {
  const buffer = await source.arrayBuffer();
  const [page] = UTIF.decode(buffer);
  if (!page) throw new Error("TIFF has no image");

  UTIF.decodeImage(buffer, page);
  const { width, height } = page;
  const pixels = UTIF.toRGBA8(page);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas is not supported");

  const imageData = context.createImageData(width, height);
  imageData.data.set(pixels);
  context.putImageData(imageData, 0, 0);

  return URL.createObjectURL(await canvasToPngBlob(canvas));
};
